export default __webpack_public_path__ + "static/media/contact.2d5ff36c.less";